import { render } from "./badgeWall.vue?vue&type=template&id=a30a97ca"
import script from "./badgeWall.vue?vue&type=script&lang=js"
export * from "./badgeWall.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__